
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_Q_SUCCESS,
  DELETE_Q_SUCCESS,
  GET_Q_FAIL,
  GET_Q_SUCCESS,
  UPDATE_Q_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  Q: [],
  exports: [],
  error: {},
};

const Q = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_Q_SUCCESS:
      return {
        ...state,
        Q: action.payload.qanda,
        exports: action.payload.exports
      };

    case GET_Q_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_Q_SUCCESS:
      return {
        ...state,
        Q: [...state.Q, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_Q_SUCCESS:
      return {
        ...state,
        Q: state.Q.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_Q_SUCCESS:
      return {
        ...state,
        Q: state.Q.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default Q;
